export const ParkStore = {
    state: {
        // 对长连接操作
        socket: null,
        // 首页企业列表 含状态
        companyList: [],
        // 首页各socket的参数
        socketParmas: {}
    },
    mutations: {
        setSocket(state, parmas) {
            state.socket = parmas.socket;
        },
        setCompanyList(state, parmas) { // 没地方用 暂且放着
            state.companyList = parmas.companyList
        },
        setSocketParmas(state, parmas) { // 设置socket的参数
            for (let item in parmas) {
                state.socketParmas[item] = parmas[item];
            }
        }
    },
    actions: {},
    getters: {}
}